export default "__VITE_ASSET__DDLXvINi__"